import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { User } from '../../store/Authentication/auth.models';
import { AppConfigData } from '../config/appConfigData';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { LoaderService } from './loader.service';

@Injectable({ providedIn: 'root' })
export class PaymentLinkService {
  constructor(
    private http: HttpClient,
        private loaderService: LoaderService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) { }

  getProjectConsumers(projectId:any): Observable<any> {
    const headers = new HttpHeaders({
      projectIdRequired: 'true', // Custom header to skip interceptor
    });
    this.loaderService.setLoading(true);
    // if (!this.configData || reload) {
    return this.http.get<any>(AppConfigData.get_project_consumers+projectId, { headers }).pipe(
      tap((data) => {
       
        this.loaderService.setLoading(false);
      })
    );
    // } else {
    //   this.loaderService.setLoading(false);
    //   return of(this.configData);
    // }
  }


   getpaymentLinksData(
      pageIndex: number = 1,
      pageSize: number | undefined,
      searchTerm: string = '',
      projectId: string,
      filter?: string,
      orderBy?: string
    ): Observable<any> {
      let url;
      url =
        `${
          AppConfigData.getPaymentLinksData + projectId
        }?pageIndex=${pageIndex}` +
        `${pageSize ? `&pageSize=${pageSize}` : ''}` +
        `${pageSize == undefined ? `&criteria=${'all'}` : ''}` +
        `${projectId ? `&projectId=${projectId}` : ''}` +
        `${
          searchTerm && searchTerm.trim() !== ''
            ? `&search=${searchTerm.trim()}`
            : ''
        }` +
        `${filter ? `&${filter}` : ''}` +
        `${orderBy ? `&${orderBy}` : ''}`;
      return this.http.get<any>(url).pipe(
        map((res) => {
          return res;
        }),
        catchError((error) => {
          console.error('getMasters failed:', error);
          return throwError(error); // Rethrow the error to propagate it further
        })
      );
    }



      createPaymentLinks(payloadData: any): Observable<any> {
        return this.http.post<any>(`${AppConfigData.createPaymentLinks}`, payloadData,).pipe(
          map((res) => {
            return res;
          }),
          catchError((error) => {
            console.error('getuserprofile failed:', error);
            return throwError(error); // Rethrow the error to propagate it further
          })
        );
      }


}
